import $ from 'jquery';
import { setCookie, getCookie } from 'utils/cookies';

const notification = () => {
    const $notification = $('.s-notification');

    if ($notification.length === 0) return;

    $notification.each(function () {
        const $el = $(this);
        const cookieName = $el.data('msg-id');
        const cookie = getCookie(cookieName);

        if (cookie) {
            $el.addClass('hide');
        }

        $el.find('.close-icon').click(() => {
            $el.addClass('hide');
            setCookie(cookieName, 1, 1);
        });
    });
};

$(() => {
    notification();
});
